import { Camera, X } from "lucide-react";
import CustomInput from "../../shared/CustomInput";
import { useQuery } from "react-query";
import { getRoles } from "../../sdk/roles/roles";
import { getBranches } from "../../sdk/branch/branch";
import { useRef, useState } from "react";
import { uploadImage } from "../../sdk/upload/upload";

const AddUser = ({
  closeAddUser,
  handleCollectUserInformation,
  adminUser,
  setAdminUser,
  errors,
  setErrors,
}) => {
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const myFile = await uploadImage(file);
      setAdminUser({ ...adminUser, profileUrl: myFile.url });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  const clearError = (field) => {
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const { data: roles } = useQuery({
    queryKey: ["roles"],
    queryFn: () => getRoles(),
  });

  const { data: branches } = useQuery({
    queryKey: ["branches"],
    queryFn: () => getBranches(),
  });

  return (
    <div
      onClick={(e) => {
        closeAddUser();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddUser}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px]">
          <button
            onClick={handleCollectUserInformation}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Next
          </button>
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Add New User
          </p>
          <p className="text-[#5C5C5C] text-[15px] font-normal">
            Provide details to create a new user
          </p>
          <div>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />

            {imagePreview ? (
              <div
                onClick={triggerFileInput}
                className="h-[110px] w-[110px] my-[20px] rounded-[20px] overflow-hidden cursor-pointer"
              >
                <img
                  src={imagePreview}
                  alt="Uploaded preview"
                  className="h-full w-full object-cover"
                />
              </div>
            ) : (
              <div
                onClick={triggerFileInput}
                className="h-[110px] w-[110px] flex flex-col justify-between rounded-[20px] my-[20px] bg-[#F3F3F3] cursor-pointer"
              >
                <div className="h-[60%] flex items-end py-[10px] justify-center w-full">
                  <Camera size={23} />
                </div>
                <div className="h-[40%] flex items-center justify-center rounded-b-[20px] bg-[#A8A8A8] text-center w-full">
                  <p className="text-[#F3F3F3] text-[12px] font-normal">
                    Upload Profile <br />
                    Picture
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="firstName"
              >
                First Name
              </label>
              <CustomInput
                placeholder="Enter your first name"
                type="text"
                value={adminUser.firstName}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, firstName: e.target.value });
                  clearError("firstName");
                }}
              />
              {errors?.firstName && (
                <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>
              )}
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="lastname"
              >
                Last Name
              </label>
              <CustomInput
                placeholder="Enter your last name"
                type="text"
                value={adminUser.lastName}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, lastName: e.target.value });
                  clearError("lastName");
                }}
              />
              {errors?.lastName && (
                <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
              )}
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="username"
              >
                Username
              </label>
              <CustomInput
                placeholder="Enter your username"
                type="text"
                value={adminUser.username}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, username: e.target.value });
                  clearError("username");
                }}
              />
              {errors?.username && (
                <p className="text-red-500 text-xs mt-1">{errors.username}</p>
              )}
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Email Address"
              >
                Email Address
              </label>
              <CustomInput
                placeholder="Enter your email address"
                type="text"
                value={adminUser.email}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, email: e.target.value });
                  clearError("email");
                }}
              />
              {errors?.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="phone"
              >
                Phone
              </label>
              <CustomInput
                placeholder="Enter your phone"
                value={adminUser.phoneNumber}
                type="text"
                onChange={(e) => {
                  setAdminUser({ ...adminUser, phoneNumber: e.target.value });
                  clearError("phoneNumber");
                }}
              />
              {errors?.phoneNumber && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.phoneNumber}
                </p>
              )}
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Branch"
              >
                Branch
              </label>
              <select
                className="h-[45px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9] bg-white"
                name="branch"
                value={JSON.stringify(adminUser.branch || "")}
                onChange={(e) => {
                  const selectedBranch = JSON.parse(e.target.value);
                  setAdminUser({ ...adminUser, branch: selectedBranch });
                  clearError("branch");
                }}
              >
                <option value="">Select a branch</option>
                {branches?.map((option) => (
                  <option key={option.id} value={JSON.stringify(option)}>
                    {option.name}
                  </option>
                ))}
              </select>
              {errors?.branch && (
                <p className="text-red-500 text-xs mt-1">{errors.branch}</p>
              )}
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="role"
              >
                Role
              </label>
              <select
                className="h-[45px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9] bg-white"
                name="role"
                value={JSON.stringify(adminUser.role)}
                onChange={(e) => {
                  const selectedRole = JSON.parse(e.target.value);
                  setAdminUser({ ...adminUser, role: selectedRole });
                  clearError("role");
                }}
              >
                <option value="">Select a role</option>
                {roles?.map((option) => (
                  <option key={option.id} value={JSON.stringify(option)}>
                    {option.name}
                  </option>
                ))}
              </select>
              {errors?.role && (
                <p className="text-red-500 text-xs mt-1">{errors.role}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
